<template>
  <v-container>
    <v-row>
      <div class="md-card md-theme-default">
        <div class="md-card-content">
          <div>
            <div class="header_title">
              <v-row no-gutters class="ma-3 header_title">
                <v-col cols="12" md="2" class="pt-6">
                  Partners
                  <br />
                  <br />
                </v-col>

                <v-col cols="12" md="10">
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="12" sm="3"> </v-col>
                    <v-col cols="12" md="2" sm="1" class="text-right">
                      <v-btn
                        height="38"
                        class="green-color"
                        width="100%"
                        dark
                        @click="addPartner"
                      >
                        Add Partner
                        <v-icon right dark>mdi-plus-circle</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div
              class="md-content md-table md-theme-default table_borders"
              table-header-color="orange"
              value
            >
              <div
                class="
                  md-content md-table-content md-scrollbar md-theme-default
                "
              >
                <table>
                  <thead class="md-card-header">
                    <tr>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Name</div>
                        </div>
                      </th>

                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Address</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Email</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Mobile</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Access Key</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Type</div>
                        </div>
                      </th>
                      <th class="md-table-head" style="position: relative">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Contact Person</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Contact Mobile</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Key</div>
                        </div>
                      </th>
                      <th class="md-table-head">
                        <div
                          class="md-table-head-container md-ripple md-disabled"
                        >
                          <div class="md-table-head-label">Action</div>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      class="md-table-row"
                      v-for="(data, index) in partners"
                      :key="data.id"
                    >
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.name || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.address || "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.email ? data.email : "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.mobile ? data.mobile : "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.access_key ? data.access_key : "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.type ? data.type : "NA" }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.contact_person }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <div class="md-table-cell-container">
                          {{ data.contact_mobile }}
                        </div>
                      </td>
                      <td class="md-table-cell">
                        <v-btn
                          x-small
                          :color="data.status_id == 1 ? 'success' : 'error'"
                          class="d-inline-block text-truncate"
                          dark
                          @click="downloadPem(data.pem_key_path)"
                        >
                          Download pem</v-btn
                        >&nbsp;&nbsp;
                      </td>
                      <td class="md-table-cell" style="min-width: 120px">
                        <v-btn
                          x-small
                          :color="data.status_id == 1 ? 'success' : 'error'"
                          class="d-inline-block text-truncate"
                          dark
                          @click="changePartnerStatus(data.id, index)"
                          fab
                        >
                          <v-icon dark>{{
                            data.status_id == 1
                              ? "mdi-lock-open-variant"
                              : "mdi-lock"
                          }}</v-icon></v-btn
                        >&nbsp;&nbsp;

                        <v-btn
                          x-small
                          color="#00b0af"
                          class="d-inline-block text-truncate"
                          dark
                          fab
                          @click="editPartner(data.id)"
                        >
                          <v-icon dark>mdi-pencil</v-icon></v-btn
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <v-pagination
              v-model="page"
              :length="totalPages"
              :page="page"
              total-visible="10"
            ></v-pagination>
          </div>
        </div>
      </div>
    </v-row>
    <v-dialog
      v-model="addPartnerModel"
      persistent
      max-width="50%"
      scrollable
      v-resize="onResize"
    >
      <v-card ref="card">
        <v-card-title class="headline"
          >{{ editFlag ? "Update" : "Add" }} Partner</v-card-title
        >
        <v-card-text class="form_bg">
          <v-container>
            <v-form v-on:submit.prevent ref="form" v-model="valid">
              <v-row>
                <v-col md="12">
                  <v-row no-gutters justify="center">
                    <v-col sm="6">
                      <image-upload
                        :image_path="partnerForm.image_path"
                        default_image="default"
                        @upload="
                          (data) => {
                            partnerForm.image = data;
                          }
                        "
                        :height="200"
                        @remove="
                          (data) => {
                            partnerForm.image = null;
                            partnerForm.map_pin = null;
                          }
                        "
                      ></image-upload>
                    </v-col>
                  </v-row>
                  <v-row class="ma-1">
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="partnerForm.name"
                        label="Name*"
                        required
                        outlined
                        background-color="#fff"
                        :rules="[(v) => !!v || 'Name is required']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="partnerForm.email"
                        label="E-mail*"
                        :rules="[
                          (v) => !!v || 'E-mail is required',
                          (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                        ]"
                        required
                        outlined
                        background-color="#fff"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <mobile-field
                        v-model="partnerForm.mobile"
                        label="Mobile Number*"
                        @change="checkMobileExist()"
                        required
                        :rules="[(v) => !!v || 'Mobile Number is required']"
                      ></mobile-field>
                    </v-col>
                    <v-col sm="6">
                      <v-text-field
                        label="Access Key*"
                        v-model="partnerForm.access_key"
                        value
                        outlined
                        background-color="#fff"
                        required
                        :rules="[(v) => !!v || 'Access Key is required']"
                      ></v-text-field>
                    </v-col>
                    <v-col sm="6">
                      <v-text-field
                        label="Type*"
                        v-model="partnerForm.type"
                        value
                        outlined
                        background-color="#fff"
                        required
                        :rules="[(v) => !!v || 'Type is required']"
                      ></v-text-field>
                    </v-col>
                    <v-col sm="6">
                      <v-text-field
                        label="Address*"
                        v-model="partnerForm.address"
                        value
                        outlined
                        background-color="#fff"
                        required
                        :rules="[(v) => !!v || 'Address required']"
                      ></v-text-field>
                    </v-col>

                    <v-col sm="6">
                      <v-text-field
                        label="Contact Person*"
                        v-model="partnerForm.contact_person"
                        value
                        outlined
                        background-color="#fff"
                        required
                        :rules="[
                          (v) => !!v || 'Contact Person Name is required',
                        ]"
                      ></v-text-field>
                    </v-col>
                    <v-col sm="6">
                      <mobile-field
                        label="Contact Person Mobile Number*"
                        v-model="partnerForm.contact_mobile"
                        value
                        outlined
                        background-color="#fff"
                        required
                        :rules="[
                          (v) =>
                            !!v || 'Contact Person Mobile Number is required',
                        ]"
                      ></mobile-field>
                    </v-col>

                    <v-col sm="6">
                      <v-file-input
                        :prefix="
                          editFlag == true &&
                          partnerForm.document != null &&
                          partnerForm.document_file_name != null
                            ? partnerForm.document_file_name.substring(0, 30) +
                              '..'
                            : ''
                        "
                        :label="editFlag ? '' : 'Select File'"
                        v-model="partnerForm.document"
                        prepend-inner-icon="mdi-paperclip"
                        prepend-icon
                        outlined
                        background-color="#fff"
                        text-truncate
                        required
                        :rules="[(v) => !!v || 'Document is required']"
                        @change="documentChange()"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-2 white--text blue-color"
            text
            @click="addUpdatePartner"
            >{{ editFlag ? "Update" : "Add" }} Partner</v-btn
          >

          <v-btn class="ma-2 white--text green-color" text @click="cancelForm"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      addPartnerModel: false,
      partners: [],
      partnerForm: {},
      page: 1,
      totalPages: 1,
      show2: false,
      valid: true,
      editFlag: false,
      partner: {},
    };
  },
  mounted() {
    this.getPartners();
  },
  computed: {},
  watch: {
    page() {
      this.getPartners();
    },
  },
  methods: {
    documentChange() {
      this.partnerForm.document_file_name = null;
    },
    getPartners() {
      let url = "partners?per_page=10&page=" + this.page;
      this.$http
        .get(url)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.partners = response.data.data;
            this.totalPages = response.data.totalPages;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    downloadPem(file) {
      window.open(process.env.VUE_APP_S3_BUCKET_URL + file);
    },
    addPartner() {
      this.partnerForm = {};
      this.addPartnerModel = true;
      setTimeout(() => {
        this.onResize();
      }, 10);
    },
    searchFIlter() {
      this.page = 1;
      this.getPartners();
    },
    checkMobileExist() {
      if (this.loading) return;
      this.showLoader("Checking");
      this.loading = true;
      this.$http
        .get(`partners?mobile=${this.partnerForm.mobile}`)
        .then((response) => {
          if (response.status == 200) {
            // this.isSearchLoading = false;
            this.hideLoader();
            this.loading = false;
            let data = response.data.data;
            if (data.length > 0) {
              this.partnerForm.mobile = null;
              this.showError("Customer exist with same mobile number");
              return false;
            } else {
              return true;
            }
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    addUpdatePartner() {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.showError("Please complete all required fields");
        return;
      }

      let formData = new FormData();
      formData.set("name", this.partnerForm.name);
      if (this.partnerForm.email != null) {
        formData.set("email", this.partnerForm.email);
      }
      if (this.partnerForm.image) {
        formData.set("image", this.partnerForm.image);
      }
      if (this.partnerForm.document) {
        formData.set("document", this.partnerForm.document);
      }
      formData.set("mobile", this.partnerForm.mobile);
      formData.set("address", this.partnerForm.address);
      formData.set("contact_person", this.partnerForm.contact_person);
      formData.set("contact_mobile", this.partnerForm.contact_mobile);
      formData.set("type", this.partnerForm.type);
      formData.set("access_key", this.partnerForm.access_key);

      this.$http({
        url:
          "partners" + (this.partnerForm.id ? `/${this.partnerForm.id}` : ""),
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data; boundary=${form._boundary}",
        },
      })
        .then((response) => {
          if (response.status == 200) {
            this.addPartnerModel = false;
            if (this.partnerForm.id)
              this.showSuccess("Partner Updated Successfully.");
            else this.showSuccess("Partner Added Successfully.");
            this.getPartners();
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    changePartnerStatus(id, index) {
      this.$http
        .put(`partners/${id}/status`)
        .then((response) => {
          if (response.status == 200) {
            let status = response.data.data.status_id;
            this.partners[index].status_id = status;
            this.showSuccess(
              `Partner ${
                status == 1 ? "activated" : "deactivated"
              } successfully`
            );
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    editPartner(id) {
      if (typeof id != "undefined") {
        this.editFlag = true;
        this.$http
          .get("partners/" + id)
          .then((response) => {
            if (response.status == 200) {
              this.partnerForm = response.data.data;
              this.addPartnerModel = true;
              setTimeout(() => {
                this.onResize();
              }, 10);
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          });
      }
    },
    gotoPartnerPage(id) {
      this.$router.push({ name: "ViewPartner", params: { partnerid: id } });
    },
    cancelForm() {
      this.$refs.form.resetValidation();
      this.addPartnerModel = false;
      this.partnerForm = {};
      this.editFlag = false;
    },
    onResize() {
      if (this.$refs.card) this.height = this.$refs.card.$el.clientHeight - 100;
    },
  },
};
</script>
<style scoped>

.validation-message {
  color: red;
  font-size: 12px;
}
.md-card {
  margin: 0 0 25px 0;
}
.hoverImage {
  background-color: rgba(54, 54, 54, 0.342);
}
</style>
